import './App.css';
import { getProtected } from './components/attendance/api/ApiAtd';
import React, { useState, useEffect } from 'react'

import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import Dashboard from './components/home/Dashboard';
import DatePicker from './components/attendance/Date';
function App() {
  const [data, setData] = useState('');
  useEffect(() => { 
    const verifyUser = async () => {
        try {
            const response = await getProtected();
            if (response.data) {
              console.log(response.data)
              setData(response.data);
              
            }
        } catch (error) {
            console.error('Error verifying user:', error);
        }
    };
  
    verifyUser();
  }, []);
  return (
    <Router>
        <Routes>
          <Route path="/date" element={<DatePicker data={data}/>} />
          <Route path="/*" element={<Dashboard data={data}/>} />
        </Routes>
    </Router>
  );
}

export default App;
